document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeSection_filterable', (section_id) => {
    return {
      focusId: '',
      filterData: [],
      init() {
        initTeleport(this.$root);

        Alpine.store('modals').register('filters', 'leftDrawer');

        window.addEventListener('popstate', this.onHistoryChange.bind(this));

        this._observeResultsMutations();
      },
      filterFormSubmit(e) {
        this.focusId = e.target.id;
        Alpine.store('modals').close('filters');
        let form = e.target.form;
        if (e.target.tagName.toLowerCase() === 'form') {
          form = e.target;
        }
        const formData = new FormData(form);
        const searchParams = new URLSearchParams(formData);
        searchParams.delete('price_range');
        this.renderPage(searchParams.toString(), e);
      },
      clearAllFilters(e) {
        // Prevent default navigation and reset any local UI state before fetching
        if (e && typeof e.preventDefault === 'function') e.preventDefault();

        // Reset price inputs (gte/lte) so price is fully cleared client-side
        try {
          document
            .querySelectorAll('input[name$=".gte"], input[name$=".lte"], input[name*="price"][type="number"]')
            .forEach((el) => {
              el.value = '';
            });

          // Reset any Alpine-powered price sliders to their limits
          document.querySelectorAll('[x-data]').forEach((el) => {
            const comp = el.__x && el.__x.$data ? el.__x.$data : null;
            if (
              comp &&
              Object.prototype.hasOwnProperty.call(comp, 'minPrice') &&
              Object.prototype.hasOwnProperty.call(comp, 'maxPrice') &&
              Object.prototype.hasOwnProperty.call(comp, 'maxLimit')
            ) {
              comp.minPrice = 0;
              comp.maxPrice = comp.maxLimit;
            }
          });
        } catch (err) {
          // no-op: UI reset is best-effort; server render will still clear filters
        }

        Alpine.store('modals').close('filters');
        this.renderPage(new URL(e.currentTarget.href).searchParams.toString());
      },
      renderPage(searchParams, event, updateURLHash = true) {
        document.getElementById('facets-results').classList.add('opacity-50');
        const url = `${window.location.pathname}?section_id=${section_id}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;
        this.filterData.some(filterDataUrl)
          ? this.renderFromCache(filterDataUrl, event)
          : this.renderFromFetch(url, event);
        if (updateURLHash) this.updateURLHash(searchParams);
      },
      renderFromFetch(url, event) {
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = responseText;
            this.filterData = [...this.filterData, { html, url }];
            this.renderMarkup(html);
          });
      },
      renderFromCache(filterDataUrl, event) {
        const html = this.filterData.find(filterDataUrl).html;
        this.renderMarkup(html);
      },
      renderMarkup(html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const innerHTML = parsed.getElementById('facets-filterable').innerHTML;
        const filterableEl = document.getElementById('facets-filterable');

        if (innerHTML !== filterableEl.innerHTML) {
          filterableEl.closest('.shopify-section').dispatchEvent(
            new CustomEvent('cascade:section:willmutate', {
              bubbles: true,
            })
          );

          setTimeout(() => {
            filterableEl.querySelectorAll('[x-teleport]').forEach((el) => {
              el.remove();
            });

            // Destroy existing slideshows in the container before replacing content
            if (window.destroySlideshowsIn) {
              window.destroySlideshowsIn(filterableEl);
            }

            filterableEl.innerHTML = innerHTML;

            this.$nextTick(() => {
              initTeleport(filterableEl);
              
              // Initialize new slideshows after DOM update
              if (window.discoverNewSlideshows) {
                window.discoverNewSlideshows(filterableEl);
              }
              
              // Set up hover handlers for new product tiles
              filterableEl.querySelectorAll('.product-tile-wrapper').forEach((tileWrapper) => {
                const splideElement = tileWrapper.querySelector('.splide--product-tile');
                if (splideElement) {
                  const splideId = splideElement.id;
                  tileWrapper.addEventListener('mouseenter', function () {
                    const instance = window.slideshows && window.slideshows[splideId];
                    if (instance && instance.length > 1) {
                      instance.go(1);
                    }
                  });
                }
              });
              
              // Remove opacity overlay after initialization
              const resultsEl = document.getElementById('facets-results');
              if (resultsEl) {
                resultsEl.classList.remove('opacity-50');
              }
            });
          }, 300);
        } else {
          document
            .getElementById('facets-results')
            .classList.remove('opacity-50');
        }

        const count = parsed.getElementById('facets-results-count').innerHTML;
        liveRegion(count);

        const element = document.getElementById(this.focusId);

        if (element) {
          setTimeout(() => {
            document.getElementById(this.focusId).focus();
          }, 50);
        }
      },
      updateURLHash(searchParams) {
        history.pushState(
          { searchParams },
          '',
          `${window.location.pathname}${
            searchParams && '?'.concat(searchParams)
          }`
        );
      },
      onHistoryChange(event) {
        const searchParams = event.state.searchParams || '';
        this.renderPage(searchParams, null, false);
      },
      _observeResultsMutations() {
        const containerEl = document.getElementById('facets-filterable');

        const mutationObserverOptions = {
          childList: true,
          attributes: false,
          // Omit (or set to false) to observe only changes to the parent node
          subtree: false,
        };

        const callback = (mutationList, observer) => {
          mutationList.forEach((mutation) => {
            if (mutation.type === 'childList') {
              mutation.target.closest('.shopify-section').dispatchEvent(
                new CustomEvent('cascade:section:hasmutated', {
                  bubbles: true,
                })
              );
            }
          });
        };

        const mutationObserver = new MutationObserver(callback);
        mutationObserver.observe(containerEl, mutationObserverOptions);
      },
    };
  });
});
